import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FoodCourt, Place } from "../types";
import { db } from "../firebase";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";

export function useGetFoodCourt(
  fcId: string,
  options?: UseQueryOptions<
    unknown,
    Error,
    (FoodCourt & { places: (Place & { uid: string })[] }) | undefined
  >,
) {
  const fetchFoodCourt = async () => {
    const docRef = doc(db, "food_courts", fcId);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) {
      throw new Error("Food court not found");
    }
    const queryDocs = await query(
      collection(db, "places"),
      where("foodCourt", "==", fcId),
    );
    const placesQuerySnapshot = await getDocs(queryDocs);
    const places = placesQuerySnapshot.docs.map((doc) => {
      return { ...doc.data(), uid: doc.id };
    });
    return { ...snapshot.data(), places };
  };

  return useQuery<
    unknown,
    Error,
    (FoodCourt & { places: (Place & { uid: string })[] }) | undefined
  >({
    queryKey: ["foodCourt", fcId],
    queryFn: fetchFoodCourt,
    ...options,
    retry(failureCount, error) {
      if (error instanceof Error && error.message === "Food court not found") {
        return false;
      }
      return failureCount < 3;
    },
  });
}
